import { remote_script_request } from '../../remote_script_request';

document.addEventListener('DOMContentLoaded', function () {
  function displayField(target, isHidden) {

    //select first option needs to be considered true as well
    isHidden = isHidden !== 'false' ? 'true' : isHidden;

    if (isHidden === 'true') {
      target.classList.add('d-none')
      target.querySelector('select').setAttribute('required', false)
    } else {
      target.classList.remove('d-none')
      target.querySelector('select').setAttribute('required', true)
    }
  }

  var participation_select = document.querySelector(
    'select#project_families_participation_required'
  );
  var participation_fair = document.querySelector(
    '.js-project_minimum_succeeded_good_enough_for_all'
  );

  if(participation_select != null && participation_select.length > 0) {
    displayField(participation_fair, 'true');

    participation_select.addEventListener('change', function () {
      displayField(participation_fair, this.value);
    });
  }

  var submit_disabled = true;

  function toggle_submit() {
    if (!submit_disabled && $(this).data('value') === $(this).val()) {
      submit_disabled = true;
      $('#flyer form input[type=submit]').attr('disabled', true);
      $('#flyer .generate-btn').removeAttr('disabled');
    } else if (submit_disabled && $(this).data('value') !== $(this).val()) {
      submit_disabled = false;
      $('#flyer .generate-btn').attr('disabled', true);
      $('#flyer form input[type=submit]').removeAttr('disabled');
    }
  }

  $('#flyer #project_flyer_text').keyup(toggle_submit);
  $('#flyer .actions').on('click', '.generate-btn', function (e) {
    e.preventDefault();

    if (!$(this).attr('disabled')) remote_script_request.call(this, e);
  });

  let errorElement = $('.has-error')[0];

  if (errorElement) {
    let y =
      errorElement.getBoundingClientRect().top + (window.pageYOffset - 100);

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
});
